import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React, { useContext, useEffect, useRef } from "react";
import { CustomerContext, CustomerContextProvider } from "@catchoftheday/customer";
import { convertProductCard, ProductGrid } from "@catchoftheday/product-components";
import { getSalesChannel } from "@catchoftheday/utilities";
import { CataloguePageType } from "../../../consts";
import { CatalogueContext, CatalogueContextProvider } from "../../../contexts/CatalogueContext.jsx";
import { useSearchQuery } from "../../../generated/graphql";
import { useSponsoredProducts } from "../../../hooks/useSponsoredProducts/useSponsoredProducts";
import { mapSearchInput } from "../../../utilities/api";
import { FacetsZone, PageLayoutZone, PaginationZone, ProductsZone, ResultsZone } from "../../layouts/PageLayout/PageLayout";
import { CataloguePageMetaTags } from "../../pure/CataloguePageMetaTags/CataloguePageMetaTags";
import { LoadingSpinner } from "../../pure/LoadingSpinner/LoadingSpinner";
import { Pagination } from "../../pure/Pagination/Pagination";
import { FacetContainer } from "../FacetContainer/FacetContainer";
import { HeaderContainer } from "../HeaderContainer/HeaderContainer";
import { jsx as ___EmotionJSX } from "@emotion/react";

var CatalogueContainerComponent = function CatalogueContainerComponent(_ref) {
  var _searchInput$paginati;

  var queryParams = _ref.queryParams,
      pageType = _ref.pageType,
      host = _ref.host;
  var hasMounted = useRef(false);

  var _useContext = useContext(CustomerContext),
      customer = _useContext.data;

  var _useContext2 = useContext(CatalogueContext),
      searchResponse = _useContext2.searchResponse,
      updateSearchResponse = _useContext2.updateSearchResponse,
      updateSearchLoading = _useContext2.updateSearchLoading,
      safeSearchEnabled = _useContext2.safeSearchEnabled,
      mobileFacetsOpen = _useContext2.mobileFacetsOpen;

  var query = queryParams.query;
  var searchInput = mapSearchInput(queryParams, customer === null || customer === void 0 ? void 0 : customer.id);
  var isCOTD = !!host && getSalesChannel(host) === "COTD";

  var _useSearchQuery = useSearchQuery({
    variables: {
      input: searchInput
    },
    skip: !query,
    onCompleted: function onCompleted(data) {
      updateSearchResponse(data.search);
    },
    notifyOnNetworkStatusChange: true
  }),
      initialData = _useSearchQuery.data,
      loading = _useSearchQuery.loading,
      refetch = _useSearchQuery.refetch;

  useEffect(function () {
    updateSearchLoading(loading);
  }, [loading, updateSearchLoading]);
  useEffect(function () {
    if (!hasMounted.current) {
      // Prevent refetch on initial render
      hasMounted.current = true;
      return;
    }

    refetch({
      input: mapSearchInput(queryParams, customer === null || customer === void 0 ? void 0 : customer.id)
    });
  }, [queryParams, refetch, customer === null || customer === void 0 ? void 0 : customer.id]);

  var _useSponsoredProducts = useSponsoredProducts({
    searchTerm: searchInput.query,
    queryParams: queryParams,
    skipQuery: ((_searchInput$paginati = searchInput.pagination) === null || _searchInput$paginati === void 0 ? void 0 : _searchInput$paginati.page) !== 1 || !isCOTD
  }),
      sponsoredItems = _useSponsoredProducts.sponsoredItems,
      sponsoredItemsLimit = _useSponsoredProducts.sponsoredItemsLimit,
      sponsoredItemsTracking = _useSponsoredProducts.sponsoredItemsTracking;

  if (!query || !loading && !(initialData !== null && initialData !== void 0 && initialData.search.results.length)) {
    // @TODO: No results page
    return ___EmotionJSX("div", null, "No results");
  }

  var _ref2 = searchResponse || (initialData === null || initialData === void 0 ? void 0 : initialData.search) || {},
      pageTitle = _ref2.pageTitle,
      results = _ref2.results,
      sortOptions = _ref2.sortOptions,
      facets = _ref2.facets,
      pagination = _ref2.pagination,
      categories = _ref2.categories,
      totalResults = _ref2.totalResults;

  var products = results === null || results === void 0 ? void 0 : results.map(function (result) {
    return convertProductCard(result.product, result.product.bestOffer);
  });
  var pageContainsAdultProducts = results === null || results === void 0 ? void 0 : results.some(function (result) {
    return result.product.adult;
  });
  return ___EmotionJSX(PageLayoutZone, _extends({}, pageType === CataloguePageType.SEARCH ? {
    "data-cnstrc-search": true
  } : {
    "data-cnstrc-browse": true
  }, {
    "data-cnstrc-num-results": totalResults
  }), ___EmotionJSX(CataloguePageMetaTags, {
    host: host,
    pageType: pageType,
    searchQuery: searchInput.query
  }), loading && ___EmotionJSX(LoadingSpinner, null), ___EmotionJSX(HeaderContainer, {
    pageTitle: pageTitle,
    sortOptions: sortOptions,
    totalFacetsApplied: facets === null || facets === void 0 ? void 0 : facets.appliedFacets.length
  }), ___EmotionJSX(ResultsZone, null, ___EmotionJSX(FacetsZone, {
    mobileFacetsOpen: mobileFacetsOpen
  }, facets && ___EmotionJSX(FacetContainer, {
    facets: facets,
    categories: categories,
    showSafeSearch: pageContainsAdultProducts,
    totalResults: totalResults
  })), ___EmotionJSX(ProductsZone, null, products && ___EmotionJSX(ProductGrid, {
    productItems: [].concat(_toConsumableArray(sponsoredItems || Array(sponsoredItemsLimit).fill(null)), _toConsumableArray(products)),
    sponsoredItemsTracking: sponsoredItemsTracking,
    displayAdultBlur: safeSearchEnabled,
    placeholderProps: {
      minHeight: "427px"
    }
  }), ___EmotionJSX(PaginationZone, null, pagination && ___EmotionJSX(Pagination, {
    pagination: pagination
  })))));
};

export var CatalogueContainer = function CatalogueContainer(props) {
  return ___EmotionJSX(CustomerContextProvider, null, ___EmotionJSX(CatalogueContextProvider, null, ___EmotionJSX(CatalogueContainerComponent, props)));
};